import Vue from 'vue'
import Vuex from 'vuex'
import { actions, getters, mutations, state } from '@/core/store/comum'
import processo from '@/core/store/processo'
import itemProcesso from '@/core/store/item-processo'
import fornecedor from '@/core/store/fornecedor'
import tipo from '@/core/store/tipo'
import ata from '@/core/store/ata'
import itemAta from '@/core/store/item-ata'
import configuracao from '@/core/store/configuracao'
import fornecedorItemAta from '@/core/store/fornecedor-item-ata'
import arquivoTemporario from '@/core/store/arquivo-temporario'
import flowbee from '@/core/store/flowbee'
import pedido from '@/core/store/pedido'
import itemPedido from '@/core/store/item-pedido'
import gerarRelatorio from '@/core/store/gerar-relatorio'
import adesao from '@/core/store/adesao'
import documentos from '@/core/store/documentos'
import comprasLegado from '@/core/store/compras-legado'
import processoUtilizacao from '@/core/store/processo-utilizacao'
import ocorrencia from '@/core/store/ocorrencia'
import penalidades from '@/core/store/penalidades'
import permissionamento from '@/core/store/permissionamento'
import aditivoApostila from '@/core/store/aditivo-apostila'
import itemAditivoApostila from '@/core/store/item-aditivo-apostila'
import relatorios from '@/core/store/relatorios'
import bpm from '@/core/store/bpm'
import partesEnvolvidas from '@/core/store/partes-envolvidas'

Vue.use(Vuex)

export default new Vuex.Store({
	actions,
	mutations,
	state,
	getters,
	modules: {
		processo,
		itemProcesso,
		fornecedor,
		tipo,
		ata,
		itemAta,
		fornecedorItemAta,
		configuracao,
		arquivoTemporario,
		flowbee,
		pedido,
		itemPedido,
		gerarRelatorio,
		adesao,
		documentos,
		comprasLegado,
		processoUtilizacao,
		ocorrencia,
		penalidades,
		permissionamento,
		aditivoApostila,
		itemAditivoApostila,
		relatorios,
		bpm,
		partesEnvolvidas,
	},
})
